<template>
  <div></div>
</template>

<script>
import store from "@/store/store";
import {insertQueryParam} from "../vendor/util";
// import * as util from "@/vendor/util";
// import * as qconst from "@/vendor/qconstants";

export default {
  name: "OfflineLifecycle",
  beforeMount() {
    this.cleanData();
    this.restoreData();
  },
  methods: {
    cleanData() {
      if (!store.state.enableOrderModeSelection) {
        this.$ls.remove('selectedOrderModeByUser');
        this.$ls.remove('userSelectedTargetTime');
      }
      if (!store.state.enableOrderModeSelectionWithTime) {
        this.$ls.remove('userSelectedTargetTime');
      }
    },
    restoreData() {
      let kioskTable = this.$ls.get('kioskTable');
      console.log('kioskTable check in restoreData: ' + kioskTable);
      if (kioskTable) {
        this.$store.commit('setIsKiosk', true);
        console.log('setIsKiosk restored');
        try {
          insertQueryParam('kiosk', kioskTable);
        } catch (e) {
          console.log('error in check kioskTable in restoreData: ' + e.message, e);
        }
        this.$store.commit('table', kioskTable);
        console.log('kioskTable restored');

        let hideSetupButton = this.$ls.get('hideSetupButton');
        if (hideSetupButton) {
          this.$store.commit('hideSetupButton', hideSetupButton);
          console.log('hideSetupButton restored');
        }
      }
      let scannedTable = this.$ls.get('scannedTable');
      if (!kioskTable && scannedTable) {
        this.$store.commit('table', scannedTable);
        console.log('scannedTable restored');
      }
      let lastOrders = this.$ls.get('lastOrders');
      if (lastOrders) {
        if (kioskTable && lastOrders.length > 30) {
          lastOrders = lastOrders.slice(-30);
        }
        this.$store.commit('lastOrders', lastOrders);
        console.log('lastOrders restored');
      }
      let inhouseStoreFilialnummer = this.$ls.get('inhouseStoreFilialnummer');
      if (inhouseStoreFilialnummer) {
        this.$store.commit('inhouseStoreFilialnummer', inhouseStoreFilialnummer);
        console.log('inhouseStoreFilialnummer restored');
      }
      let stores = this.$ls.get('stores');
      if (stores) {
        this.$store.commit('stores', stores);
        console.log('stores restored');
      }
      let appconfig = this.$ls.get('appconfig');
      if (appconfig) {
        store.commit('appconfig', appconfig);
        console.log('appconfig restored');
      }
      let selectedStore = this.$ls.get('selectedStore');
      if (selectedStore) {
        store.commit('selectedStore', selectedStore);
        console.log('selectedStore restored');
      }
      let selectedPickupTime = this.$ls.get('selectedPickupTime');
      if (selectedPickupTime) {
        this.$store.commit('selectedPickupTime', selectedPickupTime);
        console.log('selectedPickupTime restored');
      }
      // if (!store.getters.isStoreSelected) {
      //   store.commit('deleteAllCartItems');
      //   console.log('isStoreSelected is false therfore deleteAllCartItems');
      // } else {
      //   console.log('isStoreSelected is true');
      // }
      let news = this.$ls.get('news');
      if (news) {
        store.commit('news', news);
        console.log('news restored');
      }
      let userPreferences = this.$ls.get('userPreferences');
      if (userPreferences) {
        store.commit('userPreferences', userPreferences);
        console.log('userPreferences restored');
      }

      let homepageSliderImages = this.$ls.get('homepageSliderImages');
      if (homepageSliderImages) {
        store.commit('homepageSliderImages', homepageSliderImages);
        console.log('homepageSliderImages restored');
      }

      let buyersProfile = this.$ls.get('buyersProfile');
      if (buyersProfile) {
        store.commit('buyersProfile', buyersProfile);
        console.log('buyersProfile restored');
      }

      let appSettings = this.$ls.get('appSettings');
      if (appSettings) {
        store.commit('appSettings', appSettings);
        console.log('appSettings restored');
      }

      let globals = this.$ls.get('globals');
      if (globals) {
        this.$store.commit('globals', globals);
        console.log('globals restored');
      }

      let selectedOrderModeByUser = this.$ls.get('selectedOrderModeByUser');
      if (selectedOrderModeByUser) {
        this.$store.commit('restoreSelectedOrderModeByUser', selectedOrderModeByUser);
        console.log('selectedOrderModeByUser restored');
      }

    },
  },
}
</script>

<style scoped>

</style>
